import {
  fetchAlertsDebug,
  fetchSacredProfileByEmail,
  triggerAdminTestAlert,
} from "./sacred-alerts-api";

/**
 * Browser console: await testAlerts("user@example.com")
 */
export async function testAlerts(email) {
  if (!email) {
    console.warn("[testAlerts] Usage: await testAlerts('user@example.com')");
    return null;
  }

  console.group(`[testAlerts] ${email}`);

  try {
    const debug = await fetchAlertsDebug(email);
    console.log("debug report:", debug);
    console.log("next tithi birthday:", debug.users?.[0]?.next_tithi_birthday);
    console.log("birth tithi:", debug.users?.[0]?.birth_tithi);
    console.log("today alerts:", debug.users?.[0]?.today_alerts);
    console.log("schedules:", debug.users?.[0]?.schedules);
    console.log("festival/vrata:", debug.users?.[0]?.festival_vrata_alerts);
    console.log("sadhana:", debug.users?.[0]?.sadhana_reminders);
  } catch (e) {
    console.error("debug failed:", e?.response?.data?.detail || e.message);
  }

  try {
    const profile = await fetchSacredProfileByEmail(email);
    console.log("sacred profile:", profile);
  } catch (e) {
    console.warn("profile by email:", e?.response?.data?.detail || e.message);
  }

  try {
    const test = await triggerAdminTestAlert(email);
    console.log("test alert dispatched:", test);
  } catch (e) {
    console.warn("test alert (admin):", e?.response?.data?.detail || e.message);
  }

  console.groupEnd();
  return { email };
}

export function installAlertsTestConsole() {
  if (typeof window !== "undefined") {
    window.testAlerts = testAlerts;
  }
}
